import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { ColumnVisibility } from '../../../core/model/column-definition';
import { ExecutorGroup } from '../../model/executor-group';
import { ExecutorGroupService } from '../../service/data/executor-group.service';

@Component({
    selector: 'app-executor-group-manager.component',
    templateUrl: './../../../core/component/multiselect-object-manager/multiselect-object-manager.template.html',
    styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
    providers: [StandardCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExecutorGroupManagerComponent extends MultiselectObjectManagerComponentBase<ExecutorGroup> {
  constructor(
    cdf: ColumnDefinitionFactory,
    dataService: ExecutorGroupService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: StandardCommandHandlerResolver
  ) {
    super(dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = [cdf.create('EXECUTORGROUP.NAME', 'name', ColumnVisibility.mandatory)];
    this.title = 'EXECUTORGROUP.LIST_HEADER';
    this.preferencesKey = 'common.executor-group.list';
  }
}
